import {
  SELECT_BOX_LIST,
  SUCCESS_MESSAGE,
  ERROR_MESSAGE,
  IS_LOADING,
  LOGOUT,
  FOOD_ORDER_LIST,
  FOOD_ORDER_DATA,
  FOOD_ITEM_LIST,
  FOOD_ITEM_DATA,
} from '../actions/Admin';

const initialState = {
  error_message: '',
  success_message: '',
  is_loading: false,
  selectBoxList: [],
  foodItemList: [],
  foodItemData: {},
  foodOrderData: {},
  foodOrderList: [],
};

const clearableKeys = [
  'BRANCH', 'COMPANY', 'CATEGORY', 'SUB_CATEGORY', 'STAFF',
  'USER', 'CUSTOMER', 'ITEM', 'ENQUIRY', 'QUOTATION', 'PURCHASE',
  'SALE', 'DELIVERY_CHALLLAN', 'FORM', 'FOOD_ORDER'
];

const out = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SELECT_BOX_LIST:
      return { ...state, selectBoxList: payload }; 

    case SUCCESS_MESSAGE:
      return { ...state, success_message: payload };

    case ERROR_MESSAGE:
      return { ...state, error_message: payload };

    case IS_LOADING:
      return { ...state, is_loading: payload };

    case LOGOUT:
      return { ...initialState };

    default:
      // Dynamic handling for *_LIST
      if (/_LIST$/.test(type)) {
        const key = toCamelCase(type);
        console.log('Processing _LIST action:', type, 'UpperKey:', key); // Debug
        return { ...state, [key]: payload };
      }

      // Dynamic handling for *_DATA
      if (/_DATA$/.test(type)) {
        const key = toCamelCase(type);
        console.log('Processing _DATA action:', type, 'UpperKey:', key); // Debug
        return { ...state, [key]: payload };
      }

      // Dynamic handling for CLEAR_* (like CLEAR_QUOTATION, CLEAR_CUSTOMER, etc.)
      if (/^CLEAR_(.*)$/.test(type)) {
        const match = type.match(/^CLEAR_(.*)$/);
        if (match) {
          const upperKey = match[1]; // e.g., "QUOTATION"
          console.log('Processing CLEAR action:', type, 'UpperKey:', upperKey); // Debug

          if (clearableKeys.includes(upperKey)) {
            const camelKey = toCamelCase(`${upperKey}_DATA`); // e.g., "quotationData"
            console.log('Clearing:', camelKey); // Debug

            if (camelKey in initialState) {
              return {
                ...state,
                [camelKey]: initialState[camelKey],
              };
            }
          }
        }
      }

      return state;
  }
};

// Converts "BRANCH_LIST" => "branchList", "USER_DATA" => "userData"
function toCamelCase(type) {
  return type
    .toLowerCase()
    .replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

export default out;